import React from "react";
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import * as permissions from '../constants/permissions';

let Header = ({ user, logOut, callbackEnquiriesLength, pendingOrdersCount }) => {
    if (!user) {
        return false;
    }

    const allowedCallbacks = permissions.isAllowedFor(permissions.allowedCallbacks);
    const allowedRpCallbacks = permissions.isAllowedFor(permissions.allowedReceptionPointCallbacks);
    const allowedOrders = permissions.isAllowedFor(permissions.allowedOrders);
    const allowedServices = permissions.isAllowedFor(permissions.allowedReadServices);
    const allowedClients = permissions.isAllowedFor(permissions.allowedReadClients);
    const allowedSettings = permissions.isAllowedFor(permissions.allowedReadSettings);
    const allowedAnalytics = permissions.isAllowedFor(permissions.allowedAnalytics);
    const isUserRoleReceptionPoint = permissions.getRole() != permissions.RECEPTION_POINT;
    return (
        <Navbar fluid inverse>
            <Navbar.Collapse>
                <Navbar.Text>{user.get('Name')}</Navbar.Text>
                <Nav>
                    {allowedCallbacks && <LinkContainer to="/callbacks">
                        <NavItem eventKey={1} className={callbackEnquiriesLength > 0 ? 'blink' : ''}>Заявки на звонок
                            {callbackEnquiriesLength > 0 &&
                                <strong style={{ color: 'white', marginLeft: '10px' }}>+{callbackEnquiriesLength}</strong>}
                        </NavItem>
                    </LinkContainer>}
                    {allowedRpCallbacks && <LinkContainer to="/reception-point-callbacks">
                        <NavItem eventKey={7}>Обратный звонок</NavItem>
                    </LinkContainer>}
                    {allowedOrders && <LinkContainer to="/orders" isActive={(match, location) => location.pathname.startsWith('/orders')} className={pendingOrdersCount > 0 && isUserRoleReceptionPoint? 'blink' : ''}>
                        <NavItem eventKey={2}>Заказы {pendingOrdersCount > 0 && isUserRoleReceptionPoint &&
                                <strong style={{ color: 'white', marginLeft: '10px' }}>+{pendingOrdersCount}</strong>}
                        </NavItem>
                    </LinkContainer>}
                    {allowedServices && <LinkContainer to="/services">
                        <NavItem eventKey={3}>Услуги</NavItem>
                    </LinkContainer>}
                    {allowedClients && <LinkContainer to="/customers">
                        <NavItem eventKey={4}>Клиенты</NavItem>
                    </LinkContainer>}
                    {allowedSettings && <LinkContainer to="/settings">
                        <NavItem eventKey={5}>Настройки</NavItem>
                    </LinkContainer>}
                    {allowedAnalytics && <LinkContainer to="/analytics">
                        <NavItem eventKey={6}>Аналитика</NavItem>
                    </LinkContainer>}
                </Nav>
                <Nav pullRight>
                    <NavItem eventKey={100} onSelect={logOut}>
                        Выйти
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx